<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetReportList' }">预算执行报告</el-breadcrumb-item>
                <el-breadcrumb-item>预算执行{{ type == '1' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" @click="submit('ruleDetailsForm')" :loading="btnLoading">保存 </el-button>
                    <el-button size="small" plain @click="submitApproval('ruleDetailsForm')" :loading="btnLoading">保存并提交 </el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-7606" aria-describedby="el-collapse-content-7606">
                    <div role="button" id="el-collapse-head-7606" class="el-collapse-item__header is-active">
                        基本信息<i class="el-collapse-item__arrow el-icon-arrow-right is-active"></i>
                    </div>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details_temp2023">
                    <el-form-item label="单据类型：" prop="mk_report_type">
                        <el-select
                            style="width: 100%"
                            v-model="ruleForm.mk_report_type"
                            placeholder="请选择单据类型"
                            size="mini"
                            :disabled="mkTypeDisabled"
                        >
                            <el-option v-for="item in mkTypeOptions" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务实体：" prop="entity_rid">
                        <el-select
                            style="width: 100%"
                            v-model="ruleForm.entity_name"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入业务实体搜索"
                            :remote-method="remoteAccountMethod"
                            :loading="accountLoading"
                            size="mini"
                            clearable
                            @focus="dataFoucs"
                            @change="entityChange"
                        >
                            <el-option v-for="item in accountOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报销人：" prop="reim_person_rid">
                        <el-select
                            style="width: 100%"
                            v-model="ruleForm.reim_person_rid"
                            filterable
                            reserve-keyword
                            placeholder="请选择报销人"
                            size="mini"
                            clearable
                            @change="reimChange"
                        >
                            <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="承担人：" prop="cover_person_rid">
                        <el-select
                            style="width: 100%"
                            v-model="ruleForm.cover_person_rid"
                            filterable
                            reserve-keyword
                            placeholder="请选择承担人"
                            size="mini"
                            clearable
                            @change="coverChange"
                        >
                            <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="完成状态：" prop="status">
                        <el-select style="width: 100%" v-model="ruleForm.status" placeholder="请选择完成状态" size="mini" clearable disabled>
                            <el-option v-for="item in statusOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="报销事由：" prop="name">
                        <el-input v-model="ruleForm.name" autocomplete="off" placeholder="请输入报销事由" clearable size="mini"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="审批时间：" prop="approved_date">
                        <el-date-picker
                            size="mini"
                            v-model="ruleForm.approved_date"
                            type="datetime"
                            placeholder="请选择审批时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                        >
                        </el-date-picker>
                    </el-form-item> -->
                    <!-- <el-form-item label="完成时间：" prop="completion_date" v-if="ruleForm.status == 2">
                        <el-date-picker
                            size="mini"
                            v-model="ruleForm.completion_date"
                            type="datetime"
                            placeholder="请选择完成时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                        >
                        </el-date-picker>
                    </el-form-item> -->
                    <!-- <el-form-item label="实际支付时间：" prop="payment_date" v-if="ruleForm.status == 2">
                        <el-date-picker
                            size="mini"
                            v-model="ruleForm.payment_date"
                            type="datetime"
                            placeholder="请选择实际支付时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                        >
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="付款账号编码：" prop="payment_account_code">
                        <el-input
                            v-model="ruleForm.payment_account_code"
                            autocomplete="off"
                            placeholder="请输入付款账号编码"
                            clearable
                            size="mini"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input v-model="ruleForm.remark" autocomplete="off" placeholder="请输入备注" clearable size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商：" prop="supplier_rid" v-if="ruleForm.mk_report_type == '对公'">
                        <el-select
                            style="width: 100%"
                            v-model="ruleForm.supplier_name"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入供应商搜索"
                            :remote-method="remoteAccountMethod"
                            :loading="accountLoading"
                            size="mini"
                            clearable
                            @focus="dataFoucs"
                            @change="supplierChange"
                            :disabled="supplierDisabled"
                        >
                            <el-option v-for="item in accountOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转入预算：" prop="temp_budget_rid" v-if="ruleForm.mk_report_type == '对私' && type != 1">
                        <el-select
                            v-model="ruleForm.temp_budget_rid"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入预算项目名称搜索"
                            :remote-method="remoteBudgetMethod"
                            :loading="budgetLoading"
                            size="mini"
                            clearable
                        >
                            <el-option
                                v-for="item_budget in projectOptions"
                                :key="item_budget.rid"
                                :label="item_budget.name"
                                :value="item_budget.rid"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                        <div class="read_only">{{ ruleForm.created_by ? ruleForm.created_by : '' }} </div>
                    </el-form-item>
                    <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                        <div class="read_only">{{ ruleForm.updated_by ? ruleForm.updated_by : '' }} </div>
                    </el-form-item>
                    <el-collapse-item disabled :title="'预算执行列表'" name="1" v-if="type != 1">
                        <div class="for_details" v-for="(item, index) in ruleForm.executions" :key="index">
                            <el-form-item
                                label="预算项目："
                                :prop="'executions.' + index + '.budget_item_rid'"
                                :rules="{
                                    required: true,
                                    message: '预算项目不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                            >
                                <el-select
                                    v-model="item.budget_item_rid"
                                    filterable
                                    remote
                                    reserve-keyword
                                    placeholder="请输入预算项目名称搜索"
                                    :remote-method="remoteBudgetMethod"
                                    :loading="budgetLoading"
                                    size="mini"
                                    clearable
                                    value-key="rid"
                                    @change="budgetItemChange(item, index)"
                                >
                                    <el-option
                                        v-for="item_budget in projectOptions"
                                        :key="item_budget.rid"
                                        :label="item_budget.name"
                                        :value="item_budget.rid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="报销人："
                                v-show="!item.partnerShow"
                                :required="!item.partnerShow"
                                :prop="'executions.' + index + '.reim_person_rid'"
                                class="row_width"
                            >
                                <el-select
                                    v-model="item.reim_person_rid"
                                    filterable
                                    reserve-keyword
                                    placeholder="请选择报销人"
                                    size="mini"
                                    clearable
                                >
                                    <el-option
                                        v-for="item_principal in principalOptions"
                                        :key="item_principal.rid"
                                        :label="item_principal.name"
                                        :value="item_principal.rid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                label="合作方："
                                v-show="item.partnerShow"
                                :required="item.partnerShow"
                                :prop="'executions.' + index + '.partner_rid'"
                                class="row_width"
                            >
                                <el-select
                                    v-model="item.partner_rid"
                                    filterable
                                    reserve-keyword
                                    placeholder="请选择合作方"
                                    size="mini"
                                    clearable
                                    @change="partnerChange(item, index)"
                                >
                                    <el-option
                                        v-for="item_partner in partnerOptions"
                                        :key="item_partner.rid"
                                        :label="item_partner.name"
                                        :value="item_partner.rid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <!-- PARTNER_ACCOUNT -->
                            <el-form-item
                                label="合作方账户："
                                v-show="item.partnerShow"
                                :required="item.partnerShow"
                                :prop="'executions.' + index + '.partner_account_rid'"
                                class="row_width"
                            >
                                <el-select
                                    v-model="item.partner_account_rid"
                                    filterable
                                    reserve-keyword
                                    placeholder="请选择合作方账户"
                                    size="mini"
                                    clearable
                                >
                                    <el-option
                                        v-for="item_partner_account in bankAccountOptions[index]"
                                        :key="item_partner_account.rid"
                                        :label="item_partner_account.name"
                                        :value="item_partner_account.rid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                label="冲销历史："
                                :prop="'executions.' + index + '.is_write_off_history'"
                                :rules="{
                                    required: true,
                                    message: '冲销历史不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                                v-if="ruleForm.mk_report_type == '对公'"
                            >
                                <el-select
                                    v-model="item.is_write_off_history"
                                    filterable
                                    reserve-keyword
                                    placeholder="请选择是否冲销历史"
                                    size="mini"
                                    @change="historyChange(item, index)"
                                >
                                    <el-option v-for="item in historyTypeOptions" :key="item.value" :label="item.name" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="业务类型："
                                :prop="'executions.' + index + '.corp_type'"
                                :rules="{
                                    required: true,
                                    message: '业务类型不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                                v-if="ruleForm.mk_report_type == '对公'"
                            >
                                <el-select
                                    v-model="item.corp_type"
                                    filterable
                                    reserve-keyword
                                    placeholder="请选择业务类型"
                                    size="mini"
                                    :disabled="item.corpDisabled"
                                    @change="corpChange(item, index)"
                                >
                                    <el-option v-for="item in corpOptions" :key="item.value" :label="item.name" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="支付金额："
                                :prop="'executions.' + index + '.amount'"
                                :rules="{
                                    required: true,
                                    message: '支付金额不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                                v-if="item.amountShow"
                            >
                                <el-input
                                    v-model="item.amount"
                                    autocomplete="off"
                                    placeholder="请输入支付金额"
                                    @keyup.native="item.amount = oninput(item.amount)"
                                    clearable
                                    size="mini"
                                    :disabled="item.amountDisabled"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="发票金额："
                                :prop="'executions.' + index + '.invoice_amount'"
                                :rules="{
                                    required: true,
                                    message: '发票金额不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                                v-if="item.invoiceAmountShow"
                            >
                                <el-input
                                    v-model="item.invoice_amount"
                                    autocomplete="off"
                                    placeholder="请输入发票金额"
                                    @keyup.native="item.invoice_amount = oninput(item.invoice_amount)"
                                    clearable
                                    size="mini"
                                    :disabled="item.invoiceAmountDisabled"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="税金："
                                :prop="'executions.' + index + '.tax_amount'"
                                :rules="{
                                    required: true,
                                    message: '税金不能为空',
                                    trigger: 'blur'
                                }"
                                class="row_width"
                                v-if="item.taxAmountShow"
                            >
                                <el-input
                                    v-model="item.tax_amount"
                                    autocomplete="off"
                                    placeholder="请输入税金"
                                    @keyup.native="item.tax_amount = oninput(item.tax_amount)"
                                    clearable
                                    size="mini"
                                    :disabled="item.taxAmountDisabled"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="备注：" :prop="'executions.' + index + '.remark'" class="row_width">
                                <el-input
                                    v-model="item.remark"
                                    autocomplete="off"
                                    placeholder="请输入备注"
                                    clearable
                                    size="mini"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="费用类型：" :prop="'executions.' + index + '.fee_type_rid'" class="row_width">
                                <el-select v-model="item.fee_type_rid" filterable reserve-keyword placeholder="请选择费用类型" size="mini">
                                    <el-option v-for="item in feeTypeList" :key="item.rid" :label="item.name" :value="item.rid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <div class="item_btn">
                                <el-tooltip class="item" effect="dark" content="新增" placement="top-start">
                                    <el-button
                                        size="mini"
                                        class="add_delete"
                                        type="success"
                                        icon="el-icon-plus"
                                        circle
                                        @click.prevent="add(item)"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                                    <el-button
                                        size="mini"
                                        class="add_delete"
                                        type="success"
                                        icon="el-icon-copy-document"
                                        circle
                                        @click.prevent="copy(item)"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                    <el-button
                                        size="mini"
                                        class="btn_delete"
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click.prevent="removeDomain(item)"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="编辑"
                                    placement="top-start"
                                    v-if="item.checkList.length !== 0"
                                >
                                    <el-button
                                        size="mini"
                                        class="edit_btn"
                                        type="primary"
                                        @click.prevent="edit(item)"
                                        circle
                                        icon="el-icon-s-claim"
                                    ></el-button>
                                </el-tooltip>
                            </div>
                            <!-- 每行历史业务 -->
                            <el-dialog
                                title="历史业务"
                                :visible.sync="item.dialogdataVisible"
                                width="1000px"
                                v-dialogDrag
                                :before-close="dataCancel"
                            >
                                <el-input v-model="search_key" placeholder="请输入单据编号或单据事由" @keyup.enter.native="getHistory">
                                    <i slot="suffix" class="el-input__icon el-icon-search search_class" @click="getHistory"></i>
                                </el-input>
                                <el-empty description="无历史业务" v-if="historyList.length == 0"></el-empty>
                                <el-checkbox-group v-model="item.checkList" class="history" @change="checkChange">
                                    <div v-for="item in historyList" :key="item.mk_report_id" class="history_list">
                                        <div class="header_title">
                                            <span>{{ item.name }}</span>
                                            <span>{{ item.mk_report_id }}</span>
                                        </div>
                                        <el-checkbox
                                            v-for="(ite, inde) in item.budget_executions"
                                            :key="inde"
                                            :label="ite"
                                            :disabled="ite.disabled"
                                            class="item_content"
                                            @change="checkboxChange(ite)"
                                        >
                                            <div class="tag_text">
                                                <span>{{ ite.mk_report_line_id }}</span>
                                                <el-tag v-if="ite.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                                <el-tag v-else type="warning" effect="dark">到票</el-tag>
                                            </div>
                                            <div class="right_content" v-if="ite.corp_type == 2">
                                                <div class="t_div">
                                                    <span>总金额</span>
                                                    <span>￥{{ ite.amount }}</span>
                                                </div>
                                                <div class="b_div">
                                                    <span>尚未收回</span>
                                                    <span>￥{{ ite.pending_amount }}</span>
                                                </div>
                                            </div>
                                            <div class="right_content" v-else>
                                                <div class="t_div">
                                                    <span>总金额</span>
                                                    <span>￥{{ ite.invoice_amount }}</span>
                                                </div>
                                                <div class="b_div">
                                                    <span>尚未支付</span>
                                                    <span>￥{{ ite.pending_amount }}</span>
                                                </div>
                                            </div>
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dataCancel">取 消</el-button>
                                    <el-button type="primary" @click="dataSubmit">确 定</el-button>
                                </div>
                            </el-dialog>
                            <!-- 每行冲销历史 -->
                            <el-dialog
                                title="冲销历史"
                                :visible.sync="item.dialogLineVisible"
                                width="1000px"
                                v-dialogDrag
                                :before-close="dataLineCancel"
                            >
                                <el-input
                                    v-model="search_key_write"
                                    placeholder="请输入单据编号或单据事由"
                                    @keyup.enter.native="getWriteOffs"
                                >
                                    <i slot="suffix" class="el-input__icon el-icon-search search_class" @click="getWriteOffs"></i>
                                </el-input>
                                <el-empty description="无冲销历史" v-if="historyList.length == 0"></el-empty>
                                <el-checkbox-group v-model="item.checkList" class="history" :max="1">
                                    <div v-for="item in historyList" :key="item.mk_report_id" class="history_list">
                                        <div class="header_title">
                                            <span>{{ item.name }}</span>
                                            <span>{{ item.mk_report_id }}</span>
                                        </div>
                                        <el-checkbox
                                            v-for="(ite, inde) in item.budget_executions"
                                            :key="inde"
                                            :label="ite"
                                            :disabled="ite.disabled"
                                            class="item_content"
                                        >
                                            <div class="tag_text">
                                                <span>{{ ite.mk_report_line_id }}</span>
                                                <el-tag v-if="ite.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                                <el-tag v-else-if="ite.corp_type == 3" type="warning" effect="dark">到票</el-tag>
                                                <el-tag v-else-if="ite.corp_type == 4" type="warning" effect="dark">历史业务</el-tag>
                                            </div>
                                            <div class="right_content" v-if="ite.corp_type == 2">
                                                <div class="t_div">
                                                    <span>支付金额</span>
                                                    <span>￥{{ ite.amount }}</span>
                                                </div>
                                                <div class="b_div">
                                                    <span>可冲销金额</span>
                                                    <span>￥{{ ite.pending_amount }}</span>
                                                </div>
                                            </div>
                                            <div class="right_content" v-else-if="ite.corp_type == 3">
                                                <div class="t_div">
                                                    <span>发票金额</span>
                                                    <span>￥{{ ite.invoice_amount }}</span>
                                                </div>
                                                <div class="b_div">
                                                    <span>可冲销发票金额</span>
                                                    <span>￥{{ ite.pending_amount }}</span>
                                                </div>
                                            </div>
                                            <div class="right_content" v-else-if="ite.corp_type == 4">
                                                <div class="t_div" v-if="ite.invoice_amount > 0">
                                                    <span>发票金额</span>
                                                    <span>￥{{ ite.invoice_amount }}</span>
                                                </div>
                                                <div class="t_div" v-else>
                                                    <span>支付金额</span>
                                                    <span>￥{{ ite.amount }}</span>
                                                </div>
                                                <div class="b_div" v-if="ite.invoice_amount > 0">
                                                    <span>可冲销发票金额</span>
                                                    <span>￥{{ ite.invoice_amount }}</span>
                                                </div>

                                                <div class="b_div" v-else>
                                                    <span>可冲销金额</span>
                                                    <span>￥{{ ite.amount }}</span>
                                                </div>
                                            </div>
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dataLineCancel">取 消</el-button>
                                    <el-button type="primary" @click="dataLineSubmit">确 定</el-button>
                                </div>
                            </el-dialog>
                        </div>
                    </el-collapse-item>
                </el-form>
            </el-collapse>
            <!-- 选单据类型 -->
            <el-dialog
                title="请先选择单据类型"
                :visible.sync="dialogFormVisible"
                width="20%"
                v-dialogDrag
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="false"
            >
                <el-radio-group v-model="radio">
                    <el-radio :label="1">对私</el-radio>
                    <el-radio :label="2">对公</el-radio>
                </el-radio-group>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="okType">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 费用详情 -->
            <el-dialog title="费用详情" :visible.sync="dialogCheckedVisible" width="900px" v-dialogDrag :before-close="dataHistoryCancel">
                <el-form ref="form" :model="dataCheckedList" label-width="100px" class="detail_from" :rules="rulesDetails">
                    <el-form-item label="支付金额" prop="amount" v-if="amountItemShow">
                        <el-input placeholder="请输入支付金额" v-model="dataCheckedList.amount" :disabled="amountDisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="发票金额" prop="invoice_amount" v-if="invoiceAmountItemShow">
                        <el-input
                            placeholder="请输入发票金额"
                            v-model="dataCheckedList.invoice_amount"
                            :disabled="invoiceAmountDisabled"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="税金" prop="tax_amount" v-if="taxAmountItemShow">
                        <el-input placeholder="请输入税金" v-model="dataCheckedList.tax_amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" class="reamrk_item">
                        <el-input placeholder="请输入备注" type="textarea" show-word-limit v-model="dataCheckedList.remark"></el-input>
                    </el-form-item>
                    <div class="checked_">
                        <el-form-item
                            v-for="(item, index) in dataCheckedList.checkList"
                            :key="index"
                            class="checked_list"
                            :prop="'checkList.' + index + '.newAmount'"
                            :rules="{
                                required: newAmountShow,
                                message: '金额不能为空',
                                trigger: 'blur'
                            }"
                        >
                            <div class="checked_title">
                                <span>{{ item.mk_report_line_id }}</span>
                                <span>{{ item.rid }}</span>
                            </div>
                            <div class="checked_content">
                                <div class="tag_text">
                                    <span>{{ item.mk_report_line_id }}</span>
                                    &nbsp;&nbsp;
                                    <el-tag v-if="item.corp_type == 2" type="success" effect="dark">预付</el-tag>
                                    <el-tag v-else-if="item.corp_type == 3" type="warning" effect="dark">到票</el-tag>
                                    <el-tag v-else-if="item.corp_type == 4" type="warning" effect="dark">历史业务</el-tag>
                                </div>
                                <div class="right_content" v-if="item.corp_type == 2">
                                    <div class="t_div">
                                        <span>支付金额</span>
                                        <span>￥{{ item.amount }}</span>
                                    </div>
                                    <div class="b_div">
                                        <span>可冲销金额</span>
                                        <span>￥{{ item.pending_amount }}</span>
                                    </div>
                                    <div class="amount_div">
                                        <span>冲销金额</span>
                                        <span>
                                            <el-input
                                                size="mini"
                                                :max="item.pending_amount"
                                                @change="newAmountChange2"
                                                v-model="item.newAmount"
                                            ></el-input
                                        ></span>
                                    </div>
                                </div>
                                <div class="right_content" v-else-if="item.corp_type == 3">
                                    <div class="t_div">
                                        <span>发票金额</span>
                                        <span>￥{{ item.invoice_amount }}</span>
                                    </div>
                                    <div class="b_div">
                                        <span>可冲销发票金额</span>
                                        <span>￥{{ item.pending_amount }}</span>
                                    </div>
                                    <div class="amount_div" v-if="newAmountShow">
                                        <span>冲销发票金额</span>
                                        <span>
                                            <el-input
                                                size="mini"
                                                :max="item.pending_amount"
                                                @change="newAmountChange3"
                                                v-model="item.newAmount"
                                            ></el-input
                                        ></span>
                                    </div>
                                </div>
                                <div class="right_content" v-else-if="item.corp_type == 4">
                                    <div class="t_div" v-if="item.invoice_amount > 0">
                                        <span>发票金额</span>
                                        <span>￥{{ item.invoice_amount }}</span>
                                    </div>
                                    <div class="t_div" v-else>
                                        <span>支付金额</span>
                                        <span>￥{{ item.amount }}</span>
                                    </div>
                                    <div class="b_div" v-if="item.invoice_amount > 0">
                                        <span>可冲销发票金额</span>
                                        <span>￥{{ item.invoice_amount }}</span>
                                    </div>
                                    <div class="t_div" v-else>
                                        <span>可冲销金额</span>
                                        <span>￥{{ item.amount }}</span>
                                    </div>
                                    <div class="amount_div">
                                        <span v-if="item.invoice_amount > 0">冲销发票金额</span>
                                        <span v-else>冲销金额</span>
                                        <span> <el-input size="mini" v-model="item.newAmount" disabled></el-input></span>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dataHistoryCancel">取 消</el-button>
                    <el-button type="primary" @click="submitData('form')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    name: 'budgetReportEdit',
    data() {
        return {
            newAmountShow: false,
            value: '',
            dialogFormVisible: false,
            dialogCheckedVisible: false,
            amountItemShow: false,
            amountDisabled: false,
            invoiceAmountDisabled: false,
            invoiceAmountItemShow: false,
            taxAmountItemShow: false,
            historyList: [],
            dataCheckedList: [],
            radio: '1',
            btnLoading: false,
            rid: '',
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            mkTypeDisabled: true,
            //基本信息内表单验证
            ruleForm: {},
            rulesDetails: {
                amount: [{ required: true, message: '请输入支付金额', trigger: 'blur' }],
                invoice_amount: [{ required: true, message: '请输入发票金额', trigger: 'blur' }],
                tax_amount: [{ required: true, message: '请输入税金', trigger: 'blur' }]
            },
            rules: {
                mk_report_type: [{ required: true, message: '请选择单据类型', trigger: 'blur' }],
                reim_person_rid: [{ required: true, message: '请选择报销人', trigger: 'blur' }],
                cover_person_rid: [{ required: true, message: '请选择承担人', trigger: 'blur' }],
                status: [{ required: true, message: '请选择完成状态', trigger: 'blur' }],
                supplier_rid: [{ required: true, message: '请选择供应商', trigger: 'blur' }],
                name: [{ required: true, message: '请输入报销事由', trigger: 'blur' }],
                executions: {
                    budget_item_rid: [{ required: true, message: '请选择预算项目', trigger: 'blur' }],
                    amount: [{ required: true, message: '请输入支付金额', trigger: 'blur' }],
                    corp_type: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
                    is_write_off_history: [{ required: true, message: '请选择是否冲销历史', trigger: 'blur' }],
                    reim_person_rid: [{ required: true, message: '请选择报销人', trigger: 'blur' }],
                    invoice_amount: [{ required: true, message: '请输入发票金额', trigger: 'blur' }],
                    tax_amount: [{ required: true, message: '请输入税金', trigger: 'blur' }]
                }
            },
            mkTypeOptions: [
                {
                    value: '对公'
                },
                {
                    value: '对私'
                }
            ],
            statusOptions: [
                // {
                //     value: '已审批',
                //     id: 1
                // },
                {
                    value: '已完成',
                    id: 2
                }
            ],
            accountOptions: [],
            accountLoading: false,
            principalOptions: [],
            bankAccountOptions: {},
            partnerOptions: [],
            corpOptions: [],
            historyTypeOptions: [
                {
                    value: '1',
                    name: '是'
                },
                {
                    value: '2',
                    name: '否'
                }
            ],
            projectOptions: [],
            budgetLoading: false,
            supplierDisabled: false,
            search_key: '',
            search_key_write: '',
            dataList: [],
            data_index: '',
            WrittenOffLists: [],
            newExecutions: [],
            feeTypeList: []
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        this.getPrincipal();
        this.getPartner();
        this.getCorp();
        this.getFeeTypes();
        if (this.type == 1 || this.type == 5) {
            this.supplierDisabled = true; //供应商
            this.getDetails(); //获取详情
        } else {
            this.dialogFormVisible = true;
            this.radio = 1;
            this.supplierDisabled = false; //供应商
            this.ruleForm = {
                mk_report_type: '对私',
                name: '',
                entity_rid: '',
                reim_person_rid: '',
                cover_person_rid: '',
                status: 1,
                supplier_rid: '',
                completion_date: '',
                payment_date: '',
                payment_account_code: '',
                remark: '',
                approved_date: '',
                temp_budget_rid: '',
                executions: [this.getEexecutionTemplate()],
                rid: '',
                write_off_rid: ''
            };
        }
    },
    methods: {
        // mk_report_type 1-对私 2-对公
        getEexecutionTemplate(mk_report_type = 1) {
            return {
                budget_item_rid: '',
                amount: '',
                remark: '',
                reim_person_rid: this.ruleForm.reim_person_rid || '',
                corp_type: '',
                is_write_off_history: '2',
                history_type: '',
                invoice_amount: '',
                fee_type_rid: '',
                tax_amount: '',
                amountShow: mk_report_type == 1,
                invoiceAmountShow: false,
                taxAmountShow: mk_report_type == 1,
                checkList: [],
                dialogdataVisible: false,
                dialogLineVisible: false,
                partner_rid: '', // 合作方（预算项目类型为合作方的显示）
                partnerShow: false,
                partner_account_rid: '',
                history_data: [],
                history_rid: ''
            };
        },
        //费用类型下拉
        getFeeTypes() {
            let params = {};
            this.$api
                .dropdownFeeTypes(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.feeTypeList = res.data;
                    }
                })
                .catch((error) => {});
        },
        //费用详情下 预付单和 到票支付单联动
        newAmountChange2(value) {
            if (this.ruleForm.executions[this.data_index].is_write_off_history == '1') {
                this.dataCheckedList.amount = -Math.abs(value);
                this.ruleForm.executions[this.data_index].checkList[0].newAmount = -Math.abs(value);
            }
        },
        newAmountChange3(value) {
            if (this.ruleForm.executions[this.data_index].is_write_off_history == '1') {
                this.dataCheckedList.invoice_amount = -Math.abs(value);
                this.ruleForm.executions[this.data_index].checkList[0].newAmount = -Math.abs(value);
            }
        },
        //费用详情确定按钮
        submitData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.dialogCheckedVisible = false;
                } else {
                    return false;
                }
            });
        },
        //费用详情 取消
        dataHistoryCancel() {
            this.dataCheckedList.amount = '';
            this.dataCheckedList.invoice_amount = '';
            this.dataCheckedList.tax_amount = '';
            this.dataCheckedList.remark = '';
            this.ruleForm.executions[this.data_index].checkList = [];
            this.ruleForm.executions[this.data_index].corp_type = '';
            this.ruleForm.executions[this.data_index].amount = '';
            this.ruleForm.executions[this.data_index].invoice_amount = '';
            this.ruleForm.executions[this.data_index].is_write_off_history = '2';
            this.ruleForm.executions[this.data_index].corpDisabled = false;
            this.ruleForm.executions[this.data_index].amountDisabled = false;
            this.ruleForm.executions[this.data_index].invoiceAmountDisabled = false;
            this.ruleForm.executions[this.data_index].taxAmountDisabled = false;
            this.ruleForm.executions[this.data_index].tax_amount = '';
            this.ruleForm.executions[this.data_index].remark = '';
            this.dialogCheckedVisible = false;
        },
        //冲销历史行下拉 取消
        dataLineCancel() {
            this.ruleForm.executions[this.data_index].checkList = [];
            this.ruleForm.executions[this.data_index].dialogLineVisible = false;
            this.ruleForm.executions[this.data_index].corp_type = '';
            this.ruleForm.executions[this.data_index].corpDisabled = false;
            this.ruleForm.executions[this.data_index].is_write_off_history = '2';
            this.ruleForm.executions[this.data_index].amountDisabled = false;
            this.ruleForm.executions[this.data_index].invoiceAmountDisabled = false;
            this.ruleForm.executions[this.data_index].taxAmountDisabled = false;
        },
        //历史业务窗口取消
        dataCancel() {
            this.ruleForm.executions[this.data_index].checkList = [];
            this.ruleForm.executions[this.data_index].dialogdataVisible = false;
            this.ruleForm.executions[this.data_index].corp_type = '';
        },
        //历史业务确定按钮
        dataSubmit() {
            if (this.ruleForm.executions[this.data_index].checkList.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.amountDisabled = false;
                this.invoiceAmountDisabled = false;
                if (this.ruleForm.executions[this.data_index].checkList[0].corp_type == 2) {
                    this.ruleForm.executions[this.data_index].dialogdataVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[this.data_index]; //赋值弹确认框
                    this.ruleForm.executions[this.data_index].amountShow = true;
                    this.ruleForm.executions[this.data_index].invoiceAmountShow = true;
                    this.ruleForm.executions[this.data_index].taxAmountShow = true;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = true;
                    this.dialogCheckedVisible = true;
                } else {
                    this.newAmountShow = false; //业务类型为历史业务的到票时隐藏
                    this.ruleForm.executions[this.data_index].dialogdataVisible = false;
                    this.ruleForm.executions[this.data_index].amountShow = true;
                    this.ruleForm.executions[this.data_index].invoiceAmountShow = false;
                    this.ruleForm.executions[this.data_index].taxAmountShow = false;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                    this.dataCheckedList = this.ruleForm.executions[this.data_index]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                }
            }
        },
        //冲销历史确定按钮
        dataLineSubmit() {
            if (this.ruleForm.executions[this.data_index].checkList.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.ruleForm.executions[this.data_index].amountDisabled = true;
                this.ruleForm.executions[this.data_index].invoiceAmountDisabled = true;
                this.ruleForm.executions[this.data_index].taxAmountDisabled = true;
                if (this.ruleForm.executions[this.data_index].checkList[0].corp_type == 2) {
                    //预付
                    this.ruleForm.executions[this.data_index].dialogLineVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[this.data_index]; //赋值弹确认框
                    this.ruleForm.executions[this.data_index].amountShow = true;
                    this.ruleForm.executions[this.data_index].corp_type = 2;
                    this.ruleForm.executions[this.data_index].invoiceAmountShow = false;
                    this.ruleForm.executions[this.data_index].taxAmountShow = false;
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                    if (this.ruleForm.executions[this.data_index].checkList[0].newAmount) {
                        this.dataCheckedList.amount = -Math.abs(this.ruleForm.executions[this.data_index].checkList[0].newAmount);
                    }
                } else if (this.ruleForm.executions[this.data_index].checkList[0].corp_type == 3) {
                    this.ruleForm.executions[this.data_index].corp_type = 3;
                    this.ruleForm.executions[this.data_index].dialogLineVisible = false;
                    this.ruleForm.executions[this.data_index].amountShow = false;
                    this.ruleForm.executions[this.data_index].invoiceAmountShow = true;
                    this.ruleForm.executions[this.data_index].taxAmountShow = false;
                    this.amountItemShow = false;
                    this.newAmountShow = true; //业务类型为冲销历史的到票时显示
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = false;
                    this.dataCheckedList = this.ruleForm.executions[this.data_index]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                    if (this.ruleForm.executions[this.data_index].checkList[0].newAmount) {
                        this.dataCheckedList.invoice_amount = -Math.abs(this.ruleForm.executions[this.data_index].checkList[0].newAmount);
                    }
                } else if (this.ruleForm.executions[this.data_index].checkList[0].corp_type == 4) {
                    this.ruleForm.executions[this.data_index].corp_type = 4;
                    this.ruleForm.executions[this.data_index].dialogLineVisible = false;
                    this.dataCheckedList = this.ruleForm.executions[this.data_index]; //赋值弹确认框
                    this.dialogCheckedVisible = true;
                    this.ruleForm.executions[this.data_index].new_invoice_amount =
                        this.ruleForm.executions[this.data_index].checkList[0].invoice_amount;
                    if (this.ruleForm.executions[this.data_index].checkList[0].invoice_amount > 0) {
                        this.amountDisabled = false;
                        this.invoiceAmountDisabled = true;
                        this.ruleForm.executions[this.data_index].amountShow = false;
                        this.ruleForm.executions[this.data_index].invoiceAmountShow = true;
                        this.ruleForm.executions[this.data_index].taxAmountShow = false;
                        this.amountItemShow = false;
                        this.invoiceAmountItemShow = true;
                        this.taxAmountItemShow = false;
                        this.dataCheckedList.invoice_amount = -this.ruleForm.executions[this.data_index].checkList[0].invoice_amount;
                        this.ruleForm.executions[this.data_index].checkList[0].newAmount =
                            -this.ruleForm.executions[this.data_index].checkList[0].invoice_amount;
                    } else {
                        this.amountDisabled = true;
                        this.invoiceAmountDisabled = false;
                        this.ruleForm.executions[this.data_index].amountShow = true;
                        this.ruleForm.executions[this.data_index].invoiceAmountShow = false;
                        this.ruleForm.executions[this.data_index].taxAmountShow = false;
                        this.amountItemShow = true;
                        this.invoiceAmountItemShow = false;
                        this.taxAmountItemShow = false;
                        this.dataCheckedList.amount = -this.ruleForm.executions[this.data_index].checkList[0].amount;
                        this.ruleForm.executions[this.data_index].checkList[0].newAmount =
                            -this.ruleForm.executions[this.data_index].checkList[0].amount;
                    }
                }
            }
        },
        //当选中数据发生变化时
        checkChange(value) {
            var arr = this.historyList;
            if (value.length == 0) {
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        arr[index].budget_executions[inde].disabled = false;
                    }
                }
            }
        },
        //选中单条数据发生变化
        checkboxChange(ite) {
            if (ite.corp_type == 3) {
                let arr = this.historyList;
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        arr[index].budget_executions[inde].disabled = true;
                        if (ite.rid == arr[index].budget_executions[inde].rid) {
                            arr[index].budget_executions[inde].disabled = false;
                        }
                    }
                }
            } else {
                let arr = this.historyList;
                for (let index = 0; index < arr.length; index++) {
                    for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                        if (arr[index].budget_executions[inde].corp_type == 3) {
                            arr[index].budget_executions[inde].disabled = true;
                        }
                    }
                }
            }
        },
        //先选择单据类型确认事件
        okType() {
            if (this.radio == 1) {
                this.ruleForm.mk_report_type = '对私';
                this.ruleForm.executions[0].amountShow = true;
                this.ruleForm.executions[0].invoiceAmountShow = false;
                this.ruleForm.executions[0].taxAmountShow = true;
            } else {
                this.ruleForm.mk_report_type = '对公';
                this.ruleForm.executions[0].amountShow = false;
                this.ruleForm.executions[0].invoiceAmountShow = false;
                this.ruleForm.executions[0].taxAmountShow = false;
            }
            this.dialogFormVisible = false;
        },
        //报销人改变
        reimChange(value) {
            this.ruleForm.reim_person_rid = value;
            this.ruleForm.executions.forEach((value, index) => {
                if (!value.reim_person_rid) {
                    value.reim_person_rid = this.ruleForm.reim_person_rid;
                }
            });
        },
        //承担人改变
        coverChange(value) {
            this.ruleForm.cover_person_rid = value;
        },
        //删除行 预算执行列表
        removeDomain(item) {
            if (this.ruleForm.executions.length == 1) {
                this.$message({
                    message: '至少保留一条预算执行行',
                    type: 'warning'
                });
            } else {
                var index = this.ruleForm.executions.indexOf(item);
                if (index !== -1) {
                    this.ruleForm.executions.splice(index, 1);
                }
            }
        },
        //点击编辑每行
        edit(item) {
            this.dataCheckedList = item;
            if (item.is_write_off_history == '2') {
                //不冲销历史
                this.dialogCheckedVisible = true;
                if (item.checkList[0].corp_type == 2) {
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = true;
                } else {
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                }
            } else {
                //冲销历史
                if (item.checkList[0].corp_type == 2) {
                    //预付
                    this.amountItemShow = true;
                    this.invoiceAmountItemShow = false;
                    this.taxAmountItemShow = false;
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                } else if (item.checkList[0].corp_type == 3) {
                    this.amountItemShow = false;
                    this.invoiceAmountItemShow = true;
                    this.taxAmountItemShow = false;
                    this.dialogCheckedVisible = true;
                    this.amountDisabled = true;
                    this.invoiceAmountDisabled = true;
                } else if (item.checkList[0].corp_type == 4) {
                    this.dialogCheckedVisible = true;
                    if (item.checkList[0].invoice_amount > 0) {
                        this.amountDisabled = false;
                        this.invoiceAmountDisabled = true;
                        this.amountItemShow = false;
                        this.invoiceAmountItemShow = true;
                        this.taxAmountItemShow = false;
                    } else {
                        this.amountDisabled = true;
                        this.invoiceAmountDisabled = false;
                        this.amountItemShow = true;
                        this.invoiceAmountItemShow = false;
                        this.taxAmountItemShow = false;
                    }
                }
            }
        },
        //循环赋值每个 预算项目框
        budgetItemChange(item, index) {
            let res = this.projectOptions.find(function (s) {
                return s.rid == item.budget_item_rid;
            });

            if (res && res.deal_type) {
                this.ruleForm.executions[index].partnerShow = true;
            } else {
                this.ruleForm.executions[index].partnerShow = false;
            }
        },
        //循环赋值每个 预算项目框
        partnerChange(item, index) {
            this.getBankAccount(index, 'partner', item.partner_rid);
        },
        //业务类型变化
        corpChange(item, index) {
            this.ruleForm.executions[index].checkList = [];
            this.ruleForm.executions[index].amount = '';
            this.ruleForm.executions[index].invoice_amount = '';
            this.ruleForm.executions[index].tax_amount = '';
            this.ruleForm.executions[index].remark = '';
            if (item.corp_type == 2) {
                this.ruleForm.executions[index].amountShow = true;
                this.ruleForm.executions[index].invoiceAmountShow = false;
                this.ruleForm.executions[index].taxAmountShow = false;
            } else if (item.corp_type == 3) {
                this.ruleForm.executions[index].amountShow = true;
                this.ruleForm.executions[index].invoiceAmountShow = true;
                this.ruleForm.executions[index].taxAmountShow = true;
            } else if (item.corp_type == 4) {
                this.data_index = index;
                if (this.ruleForm.supplier_rid && this.ruleForm.executions[index].budget_item_rid) {
                    this.ruleForm.executions[this.data_index].dialogdataVisible = true;
                    this.getHistory();
                } else {
                    this.$message({
                        message: '请先选择供应商和预算项目',
                        type: 'warning'
                    });
                    this.ruleForm.executions[index].corp_type = '';
                }
            } else {
                this.ruleForm.executions[index].amountShow = false;
                this.ruleForm.executions[index].invoiceAmountShow = false;
                this.ruleForm.executions[index].taxAmountShow = false;
            }
        },
        //是否冲销历史
        historyChange(item, index) {
            this.data_index = index;
            this.ruleForm.executions[index].checkList = [];
            this.ruleForm.executions[index].amount = '';
            this.ruleForm.executions[index].invoice_amount = '';
            this.ruleForm.executions[index].tax_amount = '';
            this.ruleForm.executions[index].remark = '';
            this.ruleForm.executions[index].amountDisabled = false;
            this.ruleForm.executions[index].invoiceAmountDisabled = false;
            this.ruleForm.executions[index].taxAmountDisabled = false;
            if (item.is_write_off_history == '1') {
                this.ruleForm.executions[index].corp_type = '';
                if (this.ruleForm.supplier_rid && this.ruleForm.executions[index].budget_item_rid) {
                    this.ruleForm.executions[index].corpDisabled = true;
                    this.ruleForm.executions[this.data_index].dialogLineVisible = true;
                    this.getWriteOffs();
                } else {
                    this.$message({
                        message: '请先选择供应商和预算项目',
                        type: 'warning'
                    });
                    this.ruleForm.executions[index].is_write_off_history = '2';
                    this.ruleForm.executions[index].corp_type = '';
                    this.ruleForm.executions[index].corpDisabled = false;
                }
            } else {
                this.ruleForm.executions[index].corp_type = 4;
                this.ruleForm.executions[index].corpDisabled = false;
            }
        },
        //冲销历史下拉
        getWriteOffs() {
            this.ruleForm.executions[this.data_index].checkList = [];
            let params = {
                budget_item_rid: this.ruleForm.executions[this.data_index].budget_item_rid,
                // supplier_rid: 'ACCT0000000001',
                supplier_rid: this.ruleForm.supplier_rid,
                search_key: this.search_key_write
            };
            this.$api
                .toBeWrittenOffLists(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.historyList = res.data;
                    } else {
                        this.historyList = [];
                    }
                })
                .catch((error) => {});
        },
        //请求历史业务下拉接口
        getHistory() {
            let params = {
                // supplier_rid: 'ACCT0000000001',
                budget_item_rid: this.ruleForm.executions[this.data_index].budget_item_rid,
                supplier_rid: this.ruleForm.supplier_rid,
                search_key: this.search_key
            };
            this.$api
                .budgetExecutionReportHistories(params)
                .then((res) => {
                    if (res.code == 0) {
                        var arr = res.data;
                        for (let index = 0; index < arr.length; index++) {
                            for (let inde = 0; inde < arr[index].budget_executions.length; inde++) {
                                arr[index].budget_executions[inde].disabled = false;
                            }
                        }
                        this.dataList = arr;
                        this.historyList = this.dataList;
                    } else {
                        this.historyList = [];
                    }
                })
                .catch((error) => {});
        },
        //新增预算执行列表
        add(item) {
            if (this.radio == '1') {
                this.ruleForm.executions.push(this.getEexecutionTemplate(1));
            } else {
                this.ruleForm.executions.push(this.getEexecutionTemplate(2));
            }
        },
        //复制预算执行列表
        copy(item) {
            let temp = this.getEexecutionTemplate();

            for (let i in temp) {
                temp[i] = item[i];
            }

            this.ruleForm.executions.push(temp);

            this.getBankAccount(this.ruleForm.executions.length - 1, 'partner', temp.partner_rid, temp.partner_account_rid);
        },
        //正则验证
        oninput(value) {
            //可以输入正负号，小数点，保留两位
            let str = value;
            if (isNaN(str) && !/^-$/.test(str)) {
                str = '';
            }
            if (!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(str)) {
                str = str.replace(/\.\d{2,}$/, str.substr(str.indexOf('.'), 3));
            }
            return str;
        },
        //项目下拉
        remoteBudgetMethod(query) {
            if (query !== '') {
                this.budgetLoading = true;
                let params = {
                    key: query,
                    completion_date: this.ruleForm.completion_date ? this.ruleForm.completion_date : ''
                };
                this.$api
                    .searchBudgetItems(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoading = false;
                                this.projectOptions = res.data;
                            }, 200);
                        } else {
                            this.projectOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoading = false;
                this.projectOptions = [];
            }
        },
        //业务类型
        getCorp() {
            let params = {};
            this.$api
                .dropdownCorpType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.corpOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //用户下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        getBankAccount(index, rel_type, rel_rid, partner_account_rid = '') {
            let params = {
                rel_type: rel_type,
                rel_rid: rel_rid
            };

            this.$api
                .dropdownBankAccounts(params)
                .then((res) => {
                    if (res.code == 0) {
                        // watch deep 没效果，先这样兼容
                        let tempObject = {};

                        for (let i in this.bankAccountOptions) {
                            if (i == index) {
                                continue;
                            }
                            tempObject[i] = this.bankAccountOptions[i];
                        }

                        tempObject[index] = res.data;
                        this.bankAccountOptions = tempObject;
                        if (res.data.length > 1) {
                            this.ruleForm.executions[index].partner_account_rid = partner_account_rid;
                        } else {
                            this.ruleForm.executions[index].partner_account_rid = res.data[0].rid;
                        }
                    }
                })
                .catch((error) => {});
        },
        //合作方下拉
        getPartner() {
            let params = {};
            this.$api
                .dropdownPartners(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.partnerOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //重置
        dataFoucs() {
            this.accountOptions = [];
        },
        //业务实体改变
        entityChange(value) {
            this.ruleForm.entity_rid = value;
        },
        //供应商改变
        supplierChange(value) {
            this.ruleForm.supplier_rid = value;
        },
        //账户名称远程搜索方法
        remoteAccountMethod(query) {
            if (query !== '') {
                this.accountLoading = true;
                let params = {
                    name: query,
                    type: 10
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.accountLoading = false;
                                this.accountOptions = res.data;
                            }, 200);
                        } else {
                            this.accountOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.accountLoading = false;
                this.accountOptions = [];
            }
        },
        //取消
        cancel() {
            this.dialogFormVisible = false;
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetReportList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetExecutionReportDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = res.data;
                        let arr = res.data.executions;
                        let newArr = [];
                        arr.forEach((value) => {
                            newArr.push({
                                budget_item_rid: value.budget_item_rid,
                                amount: value.amount,
                                reim_person_rid: value.reim_person_rid,
                                fee_type_rid: value.fee_type_rid,
                                corp_type: value.corp_type,
                                tax_amount: value.tax_amount,
                                invoice_amount: value.invoice_amount
                            });
                        });
                        this.ruleForm.executions = newArr;
                        this.remoteAccountMethod(this.ruleForm.entity_rid);
                    }
                })
                .catch((error) => {});
        },
        //处理数据
        processParams() {
            // 先直接改，有问题再复制下
            if (this.ruleForm.mk_report_type == '对公') {
                for (let index = 0; index < this.ruleForm.executions.length; index++) {
                    if (this.ruleForm.executions[index].is_write_off_history == '2') {
                        //不冲销历史
                        if (this.ruleForm.executions[index].corp_type == 2) {
                            this.ruleForm.executions[index].invoice_amount = 0;
                            this.ruleForm.executions[index].tax_amount = 0;
                        } else if (this.ruleForm.executions[index].corp_type == 4) {
                            //业务类型历史预付
                            if (this.ruleForm.executions[index].checkList[0].corp_type == 2) {
                                let history_data = [];
                                for (let i = 0; i < this.ruleForm.executions[index].checkList.length; i++) {
                                    history_data.push({
                                        rid: this.ruleForm.executions[index].checkList[i].rid,
                                        amount: this.ruleForm.executions[index].checkList[i].newAmount
                                    });
                                }
                                this.ruleForm.executions[index].history_type = 1;
                                this.ruleForm.executions[index].history_data = history_data;
                            } else if (this.ruleForm.executions[index].checkList[0].corp_type == 3) {
                                //业务类型历史到票
                                this.ruleForm.executions[index].invoice_amount = 0;
                                this.ruleForm.executions[index].tax_amount = 0;
                                this.ruleForm.executions[index].history_type = 2;
                                this.ruleForm.executions[index].history_rid = this.ruleForm.executions[index].checkList[0].rid;
                            }
                        }
                    } else {
                        //冲销历史
                        if (this.ruleForm.executions[index].corp_type == 2) {
                            this.ruleForm.executions[index].invoice_amount = 0;
                            this.ruleForm.executions[index].tax_amount = 0;
                            this.ruleForm.executions[index].write_off_rid = this.ruleForm.executions[index].checkList[0].rid;
                        } else if (this.ruleForm.executions[index].corp_type == 3) {
                            this.ruleForm.executions[index].tax_amount = 0;
                            this.ruleForm.executions[index].amount = 0;
                            this.ruleForm.executions[index].write_off_rid = this.ruleForm.executions[index].checkList[0].rid;
                        } else if (this.ruleForm.executions[index].corp_type == 4) {
                            if (this.ruleForm.executions[index].new_invoice_amount > 0) {
                                this.ruleForm.executions[index].tax_amount = 0;
                                this.ruleForm.executions[index].amount = 0;
                                this.ruleForm.executions[index].write_off_rid = this.ruleForm.executions[index].checkList[0].rid;
                            } else {
                                this.ruleForm.executions[index].invoice_amount = 0;
                                this.ruleForm.executions[index].tax_amount = 0;
                                this.ruleForm.executions[index].write_off_rid = this.ruleForm.executions[index].checkList[0].rid;
                            }
                        }
                    }
                }
            } else {
                for (let index = 0; index < this.ruleForm.executions.length; index++) {
                    this.ruleForm.executions[index].invoice_amount = this.ruleForm.executions[index].amount;
                }
            }
        },
        // 保存
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.ruleForm.approval_status = 1;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        // 保存并提交
        submitApproval(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.ruleForm.approval_status = 2;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            this.ruleForm.rid = this.rid;
            this.$api
                .budgetExecutionReportUpdate(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            this.processParams();
            this.$api
                .budgetExecutionReportInsert(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.main_list {
    padding-top: 60px;
}
.el-collapse-item {
    width: 100%;
    .for_details {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        margin-bottom: 15px;
        border-bottom: 1px dashed #ccc;
        .item_btn {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 12px;
        }
        .el-form-item {
            display: flex;
            justify-content: space-between;
        }
        .row_width {
            width: 48%;
            /deep/.el-form-item__label {
                width: 200px;
                font-size: 13px;
            }
            /deep/.el-form-item__content {
                width: 300px !important;
                .el-input {
                    .el-input__inner {
                        width: 300px !important;
                    }
                }
            }
            /deep/.el-select {
                width: 300px !important;
                .el-input {
                    width: 300px;
                }
            }
        }
    }
}
.search_class {
    font-size: 15px;
    cursor: pointer;
}
.history {
    margin-top: 10px;
    position: relative;
    max-height: 460px;
    overflow-y: scroll;
    .is-checked {
        background: rgb(240, 250, 255);
    }
    .history_list {
        margin: 0px 0 10px 0px;
        border: 1px solid rgb(238, 238, 238);
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        .header_title {
            display: block;
            width: 940px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            box-sizing: border-box;
            display: flex;
            padding: 0 20px 0 10px;
            justify-content: space-between;
            background: #f9f9f9;
            span:nth-child(2) {
                font-size: 14px;
            }
        }
        /deep/.el-checkbox__input {
            position: absolute;
            left: 10px;
            top: 18px;
        }
        /deep/.el-checkbox__label {
            padding: 0;
            color: #333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 920px;
            height: 50px;
            box-sizing: border-box;
            padding: 0 0px 0 40px;
        }
        .item_content {
            width: 940px;
            .tag_text {
                width: 240px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .right_content {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                div {
                    display: flex;
                    justify-content: space-between;
                    width: 190px;
                    line-height: 25px;
                    font-size: 14px;
                    span {
                        display: inline-block;
                        width: 80px;
                        text-align: right;
                    }
                }
                .t_div {
                    span:nth-child(2) {
                        color: #409eff;
                    }
                }
                .b_div {
                    span:nth-child(2) {
                        color: #00b600;
                    }
                }
            }
        }
    }
}
.detail_from {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .el-form-item {
        width: 48%;
    }
    .reamrk_item {
        width: 96%;
    }
}
.checked_ {
    width: 840px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .checked_list {
        width: 840px;
        border: 1px solid rgb(238, 238, 238);
        margin: 10px 0 10px 0px;
        padding: 10px 0;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        position: relative;
        /deep/.el-form-item__content {
            margin: 0 !important;
            .el-form-item__error {
                width: 100px;
                position: absolute !important;
                top: 120px;
                left: 710px;
            }
        }
        .checked_title {
            display: block;
            width: 840px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            padding: 0 20px 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            background: #f9f9f9;
            span:nth-child(2) {
                font-size: 14px;
            }
        }
        .checked_content {
            width: 840px;
            box-sizing: border-box;
            padding: 1px 25px;
            display: flex;
            justify-content: space-between;
            .tag_text {
                min-width: 120px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .right_content {
                width: 300px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                div {
                    display: flex;
                    justify-content: space-between;
                    width: 240px;
                    line-height: 30px;
                    font-size: 14px;
                    span {
                        display: inline-block;
                        min-width: 100px;
                        text-align: right;
                    }
                }
                .t_div {
                    span:nth-child(2) {
                        color: #409eff;
                    }
                }
                .b_div {
                    span:nth-child(2) {
                        color: #00b600;
                    }
                }
                .amount_div {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    span {
                        /deep/.el-input {
                            width: 120px;
                            .el-input__inner {
                                width: 120px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>